
export default function WhyAhead() {
  const advantages = [
    'Atendendo um público que só cresce',
    'Oferecendo algo diferente da maioria dos salões',
    'Criando um novo ticket de serviço',
    'Se posicionando como referência em soluções inteligentes'
  ];

  const scrollToForm = () => {
    const formSection = document.getElementById('cadastro-form');
    formSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="bg-white py-16 sm:py-24 md:py-28 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <div className="flex items-center justify-center gap-2 sm:gap-3 mb-4 flex-wrap">
            <span className="text-3xl sm:text-4xl">📈</span>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#2A2A2A]">
              POR QUE QUEM USA
            </h2>
          </div>
          <h3 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#EA9D00]">
            ESTÁ NA FRENTE?
          </h3>
        </div>

        <p className="text-center text-base sm:text-lg md:text-xl text-[#2A2A2A] mb-8 sm:mb-12 max-w-3xl mx-auto px-4">
          Os profissionais que já trabalham com o <strong>Mix Express</strong> estão:
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-12 sm:mb-16">
          {advantages.map((advantage, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-6 sm:p-7 hover:bg-gray-100 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-4 h-4 bg-[#EA9D00] rounded-full mb-4"></div>
              <p className="text-[#2A2A2A] text-sm sm:text-base leading-relaxed">{advantage}</p>
            </div>
          ))}
        </div>

        <div className="bg-[#EA9D00]/15 rounded-full py-5 sm:py-6 px-6 sm:px-12 max-w-4xl mx-auto text-center mb-8 sm:mb-12">
          <p className="text-[#2A2A2A] text-base sm:text-lg md:text-xl font-medium leading-relaxed">
            <strong>Enquanto muitos ainda não enxergaram essa oportunidade, quem começa agora já sai na frente.</strong>
          </p>
        </div>

        <div className="text-center">
          <button
            onClick={scrollToForm}
            className="bg-[#EA9D00] text-[#2A2A2A] font-bold text-sm sm:text-base md:text-lg px-6 sm:px-10 md:px-12 py-3 sm:py-4 rounded-full hover:bg-[#d89000] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            GARANTIR MINHA VAGA GRATUITA
          </button>
        </div>
      </div>
    </section>
  );
}
